import { facilityAction } from 'src/redux/actions/constant';

const {
  SWITCH_FACILITY_SUCCESS,
  SWITCH_FACILITY_FAILURE,
  SWITCH_FACILITY_RESET,
  SWITCH_FACILITY_LOADER,
} = facilityAction;

const intialFacilityState: object = {
  isUpdatedFacilities: false,
  response: null,
  loading: false,
};

export const updateFacilityDropDownReducer = (state = intialFacilityState, action: any) => {
  switch (action.type) {
    case SWITCH_FACILITY_SUCCESS: {
      const getUpdatedFacilityId = String(action.payload.data.path).split('/');
      const facilityId = getUpdatedFacilityId[getUpdatedFacilityId.length - 1];
      localStorage.setItem('facilityId', facilityId);
      return {
        ...state,
        isUpdatedFacilities: true,
        response: action.payload,
        loading: false,
      };
    }

    case SWITCH_FACILITY_FAILURE:
      return {
        ...state,
        isGetFacilities: false,
        response: action.payload,
        loading: false,
      };

    case SWITCH_FACILITY_LOADER:
      return {
        ...state,
        loading: true,
      };

    case SWITCH_FACILITY_RESET:
      return intialFacilityState;

    default:
      return state;
  }
};
